// eslint-disable-next-line
export const formatPhoneNumber = {
  methods: {
    formatPhoneNumber(number) {
      try {
        return number.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      } catch (e) {
        return number
      }
    },
  },
}
